/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingPaymentMode } from './TrainingPaymentMode';
import {
    TrainingPaymentModeFromJSON,
    TrainingPaymentModeFromJSONTyped,
    TrainingPaymentModeToJSON,
    TrainingPaymentModeToJSONTyped,
} from './TrainingPaymentMode';

/**
 * 
 * @export
 * @interface TrainingRecurringPayment
 */
export interface TrainingRecurringPayment {
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPayment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPayment
     */
    trainingId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPayment
     */
    playerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPayment
     */
    playerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPayment
     */
    billingPeriodStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPayment
     */
    billingPeriodEnd?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPayment
     */
    validFrom?: Date | null;
    /**
     * 
     * @type {TrainingPaymentMode}
     * @memberof TrainingRecurringPayment
     */
    paymentMode?: TrainingPaymentMode;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPayment
     */
    expectedAmount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPayment
     */
    basePaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPayment
     */
    baseAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPayment
     */
    extraPaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPayment
     */
    extraAmountPaid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPayment
     */
    amountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPayment
     */
    paid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPayment
     */
    note?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPayment
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPayment
     */
    updatedAt?: Date;
}



/**
 * Check if a given object implements the TrainingRecurringPayment interface.
 */
export function instanceOfTrainingRecurringPayment(value: object): value is TrainingRecurringPayment {
    return true;
}

export function TrainingRecurringPaymentFromJSON(json: any): TrainingRecurringPayment {
    return TrainingRecurringPaymentFromJSONTyped(json, false);
}

export function TrainingRecurringPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingRecurringPayment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trainingId': json['trainingId'] == null ? undefined : json['trainingId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'billingPeriodStart': json['billingPeriodStart'] == null ? undefined : (new Date(json['billingPeriodStart'])),
        'billingPeriodEnd': json['billingPeriodEnd'] == null ? undefined : (new Date(json['billingPeriodEnd'])),
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'paymentMode': json['paymentMode'] == null ? undefined : TrainingPaymentModeFromJSON(json['paymentMode']),
        'expectedAmount': json['expectedAmount'] == null ? undefined : json['expectedAmount'],
        'basePaid': json['basePaid'] == null ? undefined : json['basePaid'],
        'baseAmountPaid': json['baseAmountPaid'] == null ? undefined : json['baseAmountPaid'],
        'extraPaid': json['extraPaid'] == null ? undefined : json['extraPaid'],
        'extraAmountPaid': json['extraAmountPaid'] == null ? undefined : json['extraAmountPaid'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'note': json['note'] == null ? undefined : json['note'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function TrainingRecurringPaymentToJSON(json: any): TrainingRecurringPayment {
    return TrainingRecurringPaymentToJSONTyped(json, false);
}

export function TrainingRecurringPaymentToJSONTyped(value?: TrainingRecurringPayment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'trainingId': value['trainingId'],
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'billingPeriodStart': value['billingPeriodStart'] == null ? value['billingPeriodStart'] : value['billingPeriodStart'].toISOString().substring(0,10),
        'billingPeriodEnd': value['billingPeriodEnd'] == null ? value['billingPeriodEnd'] : value['billingPeriodEnd'].toISOString().substring(0,10),
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString().substring(0,10),
        'paymentMode': TrainingPaymentModeToJSON(value['paymentMode']),
        'expectedAmount': value['expectedAmount'],
        'basePaid': value['basePaid'],
        'baseAmountPaid': value['baseAmountPaid'],
        'extraPaid': value['extraPaid'],
        'extraAmountPaid': value['extraAmountPaid'],
        'amountPaid': value['amountPaid'],
        'paid': value['paid'],
        'note': value['note'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

